import React, { useState } from "react";
import { Box } from "@mui/material";
import CaseStatusForm from "./Form";
import { caseManagementUrl } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseStatus } from "../../../../data/Axios/queries";


const base_url = caseManagementUrl.uri;

const CaseStatusColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "status", headerName: "Status", flex: 1.5 },
//  { field: "description", headerName: "Description", flex: 2 },
];

const actions = {
  entity: "Case status",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus: true,
};

function CaseStatusTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Case Status"
          subtitle="Manage Case Status"
          columns={CaseStatusColumns}
          FormComponent={CaseStatusForm}
          query={caseStatus}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );            
       
}


export default CaseStatusTable;